import { useLanguage } from "@/i18n/LanguageContext";
import { Language } from "@/i18n/translations";

const FlagES = () => (
  <svg viewBox="0 0 640 480" className="w-6 h-4 rounded-sm">
    <rect width="640" height="480" fill="#c60b1e"/>
    <rect width="640" height="160" y="160" fill="#ffc400"/>
  </svg>
);

const FlagGB = () => (
  <svg viewBox="0 0 640 480" className="w-6 h-4 rounded-sm">
    <rect width="640" height="480" fill="#012169"/>
    <path d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z" fill="#fff"/>
    <path d="m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z" fill="#C8102E"/>
    <path d="M241 0v480h160V0zM0 160v160h640V160z" fill="#fff"/>
    <path d="M0 193v96h640v-96zM273 0v480h96V0z" fill="#C8102E"/>
  </svg>
);

const FlagIT = () => (
  <svg viewBox="0 0 640 480" className="w-6 h-4 rounded-sm">
    <rect width="213.3" height="480" fill="#009246"/>
    <rect width="213.3" height="480" x="213.3" fill="#fff"/>
    <rect width="213.3" height="480" x="426.6" fill="#ce2b37"/>
  </svg>
);

const flags: { lang: Language; Flag: React.FC; label: string }[] = [
  { lang: "es", Flag: FlagES, label: "Español" },
  { lang: "en", Flag: FlagGB, label: "English" },
  { lang: "it", Flag: FlagIT, label: "Italiano" },
];

export const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1.5">
      {flags.map(({ lang, Flag, label }) => (
        <button
          key={lang}
          onClick={() => setLanguage(lang)}
          className={`p-1 rounded transition-all duration-200 ${
            language === lang
              ? "scale-125 opacity-100 ring-1 ring-gold"
              : "opacity-50 hover:opacity-80 hover:scale-110"
          }`}
          aria-label={label}
          title={label}
        >
          <Flag />
        </button>
      ))}
    </div>
  );
};
